class ProductImageGallery extends HTMLElement {
  constructor() {
    super();
    this.carouselInstance = undefined;
    this.mediaQueryList = globalThis.matchMedia('(max-width: 989px)');
    this.boundHandleBreakpointChange = this.handleBreakpointChange.bind(this);
  }

  connectedCallback() {
    this.type = this.dataset.type || 'carousel';
    this.perView = Number.parseInt(this.dataset.perView) || 1;
    const slidesCount = Number.parseInt(this.dataset.slidesCount, 0);

    if (slidesCount <= 1) {
      return;
    }

    // Only initialize carousel on mobile (medium-down breakpoint)
    if (this.mediaQueryList.matches) {
      this.initializeCarousel();
    }

    // Listen for breakpoint changes
    this.mediaQueryList.addEventListener(
      'change',
      this.boundHandleBreakpointChange
    );
  }

  disconnectedCallback() {
    this.mediaQueryList.removeEventListener(
      'change',
      this.boundHandleBreakpointChange
    );
    this.destroyCarousel();
  }

  /**
   * Handle breakpoint changes between mobile and desktop
   * @param {MediaQueryListEvent} event - The media query list event
   */
  handleBreakpointChange(event) {
    if (event.matches) {
      // Switched to mobile - initialize carousel
      this.initializeCarousel();
    } else {
      // Switched to desktop - destroy carousel
      this.destroyCarousel();
    }
  }

  /**
   * Destroy carousel and clean up inline styles
   */
  destroyCarousel() {
    if (!this.carouselInstance) {
      return;
    }

    // Destroy the Glide instance
    this.carouselInstance.destroy();
    this.carouselInstance = undefined;
  }

  /**
   * Initialize Glide.js carousel
   * @returns {Promise<void>}
   */
  async initializeCarousel() {
    try {
      const module = await import('@glidejs/glide');
      const Glide = module.default;

      this.carouselInstance = new Glide(this, {
        type: this.type,
        startAt: 0,
        perView: this.perView
      });

      this.carouselInstance.mount();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to load Glide.js', error);
    }
  }
}

customElements.define('product-image-gallery', ProductImageGallery);
